<template>

  <div :id="_uid" class="ui mini modal change-psw-modal">
    <div class="ui header">
      Alterar Senha
    </div>
    <div class="content">
      <div class="ui form">
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Senha atual <span class="red text">*</span></label>
            <input type="password" v-model="currentPassword">
          </div>
        </div>
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Nova senha <span class="red text">*</span></label>
            <input type="password" v-model="newPassword">
          </div>
        </div>
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Confirme a nova senha <span class="red text">*</span></label>
            <input type="password" v-model="confirmNewPassword">
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>
      <button class="ui blue button" :class="{ disabled: !canConfirm, loading: updating }" @click="onConfirm()">
        <i class="check icon"></i>
        Confirmar
      </button>
    </div>
  </div>

</template>

<script>

  import AuthService from "@/services/auth-service"

  export default { 

    data() {
      return {
        updating: false,
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      }
    },

    beforeDestroy() {
      $(".change-psw-modal").remove()
    },

    computed: {

      canConfirm() {

        let canConfirm = true

        if (!this.currentPassword || !this.newPassword || !this.confirmNewPassword)
          canConfirm = false

        return canConfirm
      },
    },
    
    methods: {

      show() {

        this.currentPassword = ""
        this.newPassword = ""
        this.confirmNewPassword = ""

        $(`#${this._uid}`).modal("show")
      },

      hide() {
        $(`#${this._uid}`).modal("hide")
      },

      async onConfirm() {

        if (this.newPassword != this.confirmNewPassword) {
          this.$msg.info("Senha não confirmada corretamente")
          return
        }

        this.updating = true

        try {

          await new AuthService().updatePassword(this.currentPassword, this.newPassword)

          this.hide()

          this.$msg.success("Senha alterada com sucesso")
          
        } catch (error) {

          if (error.code && error.code == "auth/wrong-password") {
            this.$msg.warn("Senha atual inválida")
          } else {
            this.$errorHandler(error)
          }          

        } finally {
          
          this.updating = false
        }
      },
    },
  }

</script>

